var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHaulout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 7.78 7.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6007e;stroke-width:.06px;}.cls-1,.cls-2{stroke:#e6007e;stroke-miterlimit:3.86;}.cls-2{fill:none;stroke-width:.28px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Travel_hoist"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1.14 3.18 6.61 3.18 6.61 3.49 6.61 3.81 6.5 4.13 6.32 4.45 6 4.7 5.69 4.86 5.3 4.97 4.96 5.11 4.64 5.22 4.3 5.39 4.02 5.64 3.86 5.81 3.64 5.54 3.33 5.31 3 5.17 2.66 5.03 2.34 4.94 2.03 4.8 1.66 4.61 1.36 4.27 1.14 3.85 1.14 3.49 1.14 3.18 1.14 3.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.14,7.05V.14H7.64V7.05M1.14,.27V3.63M6.61,.25V3.48m-5.47-.32H6.61m-2.75,3.18c-.06-.27-.03-.66-.22-.82-.91-.76-2.5-.44-2.5-2.05m2.72,2.87c.05-.29,.06-.66,.25-.82,.91-.76,2.5-.44,2.5-2.05"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaulout);
export default __webpack_public_path__ + "static/media/haulout.a90bafe621a629251166eb68c22124f8.svg";
export { ForwardRef as ReactComponent };